var e = Object.defineProperty, c = Object.defineProperties;
var m = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var a = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var p = (o, n, r) => n in o ? e(o, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[n] = r, i = (o, n) => {
  for (var r in n || (n = {}))
    a.call(n, r) && p(o, r, n[r]);
  if (d)
    for (var r of d(n))
      s.call(n, r) && p(o, r, n[r]);
  return o;
}, t = (o, n) => c(o, m(n));
import { jsx as u } from "react/jsx-runtime";
import { components as w } from "react-select";
function D(o) {
  return /* @__PURE__ */ u(w.DropdownIndicator, t(i({}, o), { innerProps: t(i({}, o.innerProps), {
    onMouseDown: () => {
    },
    onTouchEnd: () => {
    }
  }) }));
}
D.displayName = "DropdownIndicator";
export {
  D as DropdownIndicator
};
//# sourceMappingURL=DropdownIndicator.es.js.map
